// Info-Badge (ⓘ) mit einblendbarem Hilfstext, für Sektions-/Panel-Überschriften.
// Liefert einen HTML-String, der in bestehende innerHTML-Templates eingesetzt wird.
// Popover-Verhalten kommt aus .kl-info-tip (packages/frontend-design/styles/patterns.css).

function escapeHtml(s: string): string {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

/**
 * Info-Badge neben eine Überschrift setzen:
 *   `<h3 class="kl-section-title">Wert-Mappings ${infoBadge('…')}</h3>`
 */
export function infoBadge(text: string): string {
  const safe = escapeHtml(text);
  return (
    `<span class="kl-info-tip" tabindex="0" role="note" aria-label="${safe}">` +
    `<span class="v-icon fa-light fa-circle-info" aria-hidden="true"></span>` +
    `<span class="kl-info-tip__pop">${safe}</span>` +
    `</span>`
  );
}
